import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { GeneralScheduleAdd, GeneralScheduleGrabber } from './components/GeneralScheduleSidebar';
import { GeneralScheduleEdit } from './components/GeneralScheduleEdit';
import { GeneralScheduleGuest } from './components/GeneralScheduleGuest';

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const GeneralScheduleConfig: CustomJsonComponentConfig = {
  // Tip:
  // Replace this with the URL for the JSONSchema your component data uses.
  // This makes sure PageComponents with this schema will render your components.
  schemaUrl: 'https://withjoy.com/assets/public/schemas/scheduleschema.json',
  componentType: 'GeneralSchedule',
  adminSidebarComponent: {
    addComponentView: GeneralScheduleAdd,
    dragComponentView: GeneralScheduleGrabber,
    editComponentView: GeneralScheduleEdit,
    createComponentView: GeneralScheduleEdit,
  },
  guestSiteComponent: GeneralScheduleGuest,
};
